import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const resourceSets = {
  aiml: [
    {
      title: "Syllabus",
      items: [
        {
          label: "Syllabus / IA Coverage",
          href: "#",
        },
      ],
    },
    {
      title: "Timetable",
      items: [
        {
          label: "4th Semester Timetable",
          href: "#",
        },
      ],
    },
    {
      title: "Academic Calendar",
      items: [
        {
          label: "Calendar of Events",
          href: "#",
        },
      ],
    },
    {
      title: "Lab Manuals",
      items: [
        {
          label: "Lab Manual",
          href: "#",
        },
      ],
    },
      {
        title: "Question Papers & Solutions",
        items: [
          {
            label: "Question Paper and Solution",
            href: "#",
          },
        ],
      },
    {
      title: "Add-On Subjects",
      items: [
        {
          label: "Add-On Course Syllabus",
          href: "#",
        },
      ],
    },
    {
      title: "Published Papers & Patents",
      items: [
        {
          label: "Published Paper / Patent",
          href: "#",
        },
      ],
    },
    {
      title: "Mentor List",
      items: [
        {
          label: "Mentor List 2025-26",
          href: "#",
        },
      ],
    },
  ],
  ece: [
    {
      title: "Syllabus",
      items: [
        {
          label: "2022 Scheme",
          href: "#",
        },
      ],
    },
    {
      title: "Timetable",
      items: [
        {
          label: "4th Semester Timetable",
          href: "#",
        },
      ],
    },
    {
      title: "Academic Calendar",
      items: [
        {
          label: "COE 4th SEM",
          href: "#",
        },
      ],
    },
    {
      title: "Lab Manuals",
      items: [
        {
          label: "Lab Manual",
          href: "# ",
        },
      ],
    },
    {
      title: "Question Papers & Solutions",
      items: [
        {
          label: "Question Paper",
          href: "#",
        },
      ],
    },
    {
      title: "Add-On Subjects",
      items: [
        {
          label: "Add-On Course Syllabus",
          href: "#",
        },
      ],
    },
    {
      title: "Published Papers & Patents",
      items: [
        {
          label: "Published Paper / Patent",
          href: "#",
        },
      ],
    },
    {
      title: "Mentor List",
      items: [
        {
          label: "Mentor List 2025-26",
          href: "#",
        },
      ],
    },
  ],
};

const StudentResourceTemplate = ({ resourcePage }) => {
  const programmePath = resourcePage.programmePath || `/programme/${resourcePage.short.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`;
  const sections = resourcePage.sections?.length
    ? resourcePage.sections
    : resourceSets[resourcePage.resourceSet] || resourceSets.aiml;
  const [openSections, setOpenSections] = useState(() =>
    sections.map((section) => section.title)
  );

  const toggleSection = (title) => {
    setOpenSections((current) =>
      current.includes(title)
        ? current.filter((sectionTitle) => sectionTitle !== title)
        : [...current, title]
    );
  };

  return (
    <main className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
      <Link
        to={programmePath}
        className="flex w-fit items-center gap-2 text-sm font-semibold text-brand hover:underline mb-10"
      >
        <ArrowLeft size={16} />
        Back to Programme
      </Link>

      <h1
        className="text-3xl md:text-4xl text-brand font-semibold mt-2"
        style={{ fontFamily: "'Cormorant Garamond', serif" }}
      >
        {resourcePage.department} Student Resources
      </h1>
      <p className="text-[#2a2a2a]/85 leading-relaxed text-[15.5px] mt-3 max-w-3xl">
        {resourcePage.description}
      </p>

      <div className="space-y-4 mt-8">
        {sections.map((section) => {
          const isOpen = openSections.includes(section.title);

          return (
            <section key={section.title} className="bg-white border border-brand/15 p-5">
              <button
                type="button"
                onClick={() => toggleSection(section.title)}
                className="w-full flex items-center justify-between gap-3 text-left"
                aria-expanded={isOpen}
              >
                <span className="text-xs uppercase tracking-widest text-brand font-semibold font-sans-ui">
                  {section.title}
                </span>
                <span className="text-brand text-sm">{isOpen ? "−" : "+"}</span>
              </button>

              {isOpen && section.semesters?.length > 0 && (
              <div className="space-y-2 mt-4">
                {section.semesters.map((semester) => (
                  <details
                    key={semester.label}
                    className="border border-brand/10 bg-surface/40"
                  >
                    <summary className="cursor-pointer px-4 py-3 text-sm font-semibold text-brand">
                      {semester.label}
                    </summary>
                    {semester.items.length > 0 ? (
                      <ul className="space-y-2 px-4 pb-4">
                        {semester.items.map((item) => (
                          <li key={item.label}>
                            <a
                              href={item.href || "#"}
                              target="_blank"
                              rel="noreferrer"
                              className="text-sm text-[#2a2a2a] hover:text-brand transition"
                            >
                              {item.label}
                            </a>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p className="text-sm text-[#3a3a3a]/70 italic px-4 pb-4">
                        Content will be updated soon.
                      </p>
                    )}
                  </details>
                ))}
              </div>
              )}

              {isOpen && !section.semesters?.length && section.items.length > 0 && (
              <ul className="space-y-2 mt-4">
                {section.items.map((item) => (
                  <li key={item.label}>
                    <a
                      href={item.href || "#"}
                      target="_blank"
                      rel="noreferrer"
                      className="text-sm text-[#2a2a2a] hover:text-brand transition"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
              )}

              {isOpen && !section.semesters?.length && section.items.length === 0 && (
              <p className="text-sm text-[#3a3a3a]/70 italic mt-4">
                Content will be updated soon.
              </p>
              )}
            </section>
          );
        })}
      </div>
    </main>
  );
};

export default StudentResourceTemplate;
